export default "__VITE_ASSET__3f39635a__"